import TaskManagementBase from './TaskManagementBase';

export default function DesignSampling({ user }) {
  return (
    <TaskManagementBase
      user={user}
      moduleName="Design & Sampling"
      moduleTitle="Design & Sampling"
      moduleDescription="Design creation, approval workflow, and sampling tracking with task management"
    />
  );
}
